"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderCarousel = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
const react_1 = __importDefault(require("react"));
const react_spring_1 = require("react-spring");
const StyledSliderCarouselWrapper = components_core_1.styled.div `
  display: flex;
  align-items: center;
  width: 100%;
`;
const StyledSliderContainer = components_core_1.styled.div `
  touch-action: auto;
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  display: ${props => props.totalColumnCount <= props.visibleColumnCount ? 'flex' : 'grid'};
  grid-template-columns: ${props => `repeat(${props.totalColumnCount}, ${(1 / props.visibleColumnCount) *
    100}%)`};
  ${props => props.totalColumnCount <= props.visibleColumnCount &&
    'justify-content: space-around;'}
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    justify-content: ${props => props.totalColumnCount === props.visibleColumnCount &&
    props.visibleColumnCount >= 2
    ? 'space-between'
    : props.totalColumnCount < props.visibleColumnCount
        ? 'flex-start'
        : 'unset'};
  }
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    grid-template-columns: ${props => `repeat(${props.totalColumnCount}, ${(1 / props.visibleColumnCount) *
    100}%)`};
  }
`;
const StyledChildWrapper = (0, components_core_1.styled)(react_spring_1.animated.div) `
  display: inline-flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  white-space: normal;
  will-change: transform;
  @media screen and (min-width: ${components_core_1.Breakpoints.b560}px) {
    ${props => !props.singleelement && 'width: 100%;'}
  }
`;
function SliderCarousel({ children, slider, visibleTabCount = 1, slideGroup = 2, totalElements, sliderElementRef, singleelement }) {
    const tabs = react_1.default.Children.toArray(children);
    const totalTabCount = totalElements || tabs.length;
    const { springs, bindGestureHandlers } = slider;
    // Calculate slice according with carousel specs
    const getSlideTransformStyle = (x) => {
        if (visibleTabCount > 1) {
            return `translate3d(${x * -slideGroup}px,0,0)`;
        }
        return `translate3d(${x * -0.97}px,0,0)`;
    };
    return (react_1.default.createElement(StyledSliderCarouselWrapper, { className: "slider-carousel-wrapper" },
        react_1.default.createElement(StyledSliderContainer, { ref: sliderElementRef, totalColumnCount: totalTabCount, visibleColumnCount: visibleTabCount, className: "slider-carousel-container" }, springs.map(({ x }, index) => (react_1.default.createElement(StyledChildWrapper, Object.assign({}, bindGestureHandlers(), { key: index, style: { transform: x.interpolate(getSlideTransformStyle) }, singleelement: singleelement, className: "slider-spring-wrapper" }), tabs[index]))))));
}
exports.SliderCarousel = SliderCarousel;
